import { useState } from "react";
import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { getLatest, getTopRated } from "@/utils/media";
import type { MediaItem, MediaType } from "@/types/media";

const tabs: { key: string; label: string }[] = [
  { key: "latest", label: "最新更新" },
  { key: "top", label: "高分推荐" },
  { key: "movie", label: "高分电影" },
  { key: "tv", label: "热播剧集" },
];

function resolve(key: string): MediaItem[] {
  switch (key) {
    case "top":
      return getTopRated(undefined, 8);
    case "movie":
      return getTopRated("movie" as MediaType, 8);
    case "tv":
      return getTopRated("tv" as MediaType, 8);
    default:
      return getLatest(undefined, 8);
  }
}

export default function FeaturedSection() {
  const [activeTab, setActiveTab] = useState("latest");
  const items = resolve(activeTab);

  return (
    <section>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-1 rounded-full bg-primary-500" />
          <h2 className="font-heading text-xl font-700 text-foreground-950 md:text-2xl">精选内容</h2>
        </div>
        <div className="flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveTab(tab.key)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-500 transition-colors md:text-sm ${
                activeTab === tab.key
                  ? "bg-primary-500 text-background-950"
                  : "text-foreground-400 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 xl:grid-cols-4">
        {items.map((item) => (
          <MediaCard key={item.id} item={item} />
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link
          to="/category/movie"
          className="inline-flex h-11 items-center gap-2 rounded-md border border-background-300 px-6 text-sm font-500 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400"
        >
          浏览全部影片
          <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}